var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHammerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.701604,
    width: 20.248,
    height: 11.0896,
    rx: 5.5448,
    transform: "matrix(0.712567 0.701604 -0.712567 0.701604 18.872 0.716426)",
    stroke: "#657B90"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6651 23.8407C5.84589 23.4951 6.16019 23.1859 6.62031 22.7332C6.6417 22.7122 6.66341 22.6908 6.68544 22.6691L14.2745 15.1968C14.2965 15.1751 14.3182 15.1538 14.3396 15.1327C14.7993 14.6797 15.1134 14.3702 15.4644 14.1922C16.1883 13.8251 17.0477 13.8251 17.7716 14.1922C18.1226 14.3702 18.4366 14.6797 18.8964 15.1327C18.9178 15.1538 18.9395 15.1751 18.9615 15.1968C18.9835 15.2185 19.0052 15.2399 19.0266 15.2609C19.4867 15.7136 19.801 16.0228 19.9818 16.3684C20.3547 17.0812 20.3547 17.9274 19.9818 18.6401C19.801 18.9857 19.4867 19.2949 19.0266 19.7476C19.0052 19.7687 18.9835 19.79 18.9615 19.8117L11.3724 27.284C11.3504 27.3057 11.3287 27.3271 11.3073 27.3481C10.8476 27.8012 10.5335 28.1106 10.1825 28.2886C9.45865 28.6558 8.59921 28.6558 7.87534 28.2886C7.52435 28.1106 7.2103 27.8012 6.75053 27.3481C6.72915 27.3271 6.70746 27.3057 6.68544 27.284C6.66341 27.2623 6.6417 27.241 6.62031 27.2199C6.16019 26.7672 5.84589 26.458 5.6651 26.1124C5.29226 25.3997 5.29226 24.5535 5.6651 23.8407Z",
    stroke: "#657B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammerIcon);
export default __webpack_public_path__ + "static/media/hammer-icon.937e9c3abd47cad5cd1c401887e4349b.svg";
export { ForwardRef as ReactComponent };